import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { FaIcon } from "../../utility/FaIcon";


const FaArrowUpIcon = FaIcon(FaArrowUp);

const jumpToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname, search, hash, key } = useLocation();

  const handleScroll = () => {
    setIsVisible(window.scrollY > 200);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest("a");
      if (!anchor) return;
      if (anchor.target === "_blank" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) {
        return;
      }
      if (/^https?:\/\//i.test(href) && !href.startsWith(window.location.origin)) {
        return;
      }
      // Keep in-page section links (e.g. #enquiry)
      if (href.startsWith("#") && href.length > 1) {
        return;
      }

      const nextPath = (() => {
        try {
          return new URL(href, window.location.origin).pathname;
        } catch {
          return href.split("?")[0].split("#")[0];
        }
      })();
      if (nextPath === "/packages" || nextPath.startsWith("/packages/")) {
        return;
      }

      jumpToTop();
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (hash && hash.length > 1) {
      const id = decodeURIComponent(hash.slice(1));
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => window.clearTimeout(timer);
    }

    jumpToTop();
    const frame = window.requestAnimationFrame(jumpToTop);
    const quick = window.setTimeout(jumpToTop, 50);
    const afterLazy = window.setTimeout(jumpToTop, 350);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(quick);
      window.clearTimeout(afterLazy);
    };
  }, [pathname, search, hash, key]);

  return (
    <>
      <style>{`
        .scroll-top-btn {
          position: fixed;
          bottom: 150px;
          right: 24px;
          background: #000;
          color: #fff;
          padding: 12px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }

        .scroll-top-btn.hide {
          opacity: 0;
          pointer-events: none;
          transform: translateY(20px);
        }

        .scroll-top-btn.show {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      <div
        className={`scroll-top-btn ${isVisible ? "show" : "hide"}`}
        onClick={scrollToTop}
      >
        <FaArrowUpIcon />
      </div>
    </>
  );
};

export default ScrollToTop;
